export const fetchLessonsTypes = [
  'FETCH_LESSONS',
  'FETCH_LESSONS_SUCCES',
  'FETCH_LESSONS_FAIL',
];

export const fetchLessonTypes = [
  'FETCH_LESSON',
  'FETCH_LESSON_SUCCESS',
  'FETCH_LESSON_FAIL',
];

export const fetchUserLessonTypes = [
  'FETCH_USER_LESSON',
  'FETCH_USER_LESSON_SUCCESS',
  'FETCH_USER_LESSON_FAIL',
];

export const refundLessonTypes = [
  'REFUND_LESSON',
  'REFUND_LESSON_SUCCESS',
  'REFUND_LESSON_FAIL',
];

export const SET_LESSON_PAGE = 'SET_LESSON_PAGE';
export const SET_LESSON_PAGE_COUNT = 'SET_LESSON_PAGE_COUNT';



// WEBPACK FOOTER //
// ./src/modules/lessons/action_types.js